import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "CEO, TechStart India",
      content: "GWIT delivered our e-commerce platform on time and exceeded our expectations. Their expertise in web development is remarkable.",
      rating: 5
    },
    {
      name: "Priya Sharma",
      role: "Founder, CryptoVentures",
      content: "The blockchain solution they built for us was secure, scalable, and exactly what we needed. Highly recommended for crypto projects!",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "CTO, GlobalTech Solutions",
      content: "Their IT consultancy helped us transform our entire digital infrastructure. The team's knowledge and professionalism are outstanding.",
      rating: 5
    },
    {
      name: "Anita Patel",
      role: "Product Manager, FinApp",
      content: "The mobile app they developed has received great feedback from our users. Fast delivery and excellent quality.",
      rating: 5
    },
    {
      name: "David Wilson",
      role: "Director, CloudScale Inc",
      content: "Working with GWIT on our cloud migration was seamless. They understood our needs and delivered beyond expectations.",
      rating: 5
    },
    {
      name: "Sneha Reddy",
      role: "Startup Founder",
      content: "From concept to launch, GWIT was with us every step. Their support is unmatched in the industry.",
      rating: 5
    }
  ];

  // Duplicate for infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section 
      className="relative py-24 sm:py-32 overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-600/5 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Section Header */}
        <motion.div
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs sm:text-sm font-bold tracking-[0.2em] uppercase text-blue-400 mb-4 block">
            Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6">
            What Our Clients Say
          </h2>
          <p className="text-lg text-slate-300">
            Don't just take our word for it - hear from our satisfied clients.
          </p>
        </motion.div>
      </div>

      {/* Marquee Container */}
      <div className="relative overflow-hidden">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#030712] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#030712] to-transparent z-10" />

        {/* Scrolling Testimonials */}
        <motion.div
          className="flex gap-6"
          animate={{ x: [0, -50 * testimonials.length * 20] }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 50,
              ease: "linear"
            }
          }}
        >
          {duplicatedTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[350px] glass rounded-2xl p-6 glass-hover"
            >
              {/* Quote Icon */}
              <Quote className="w-8 h-8 text-blue-500/30 mb-4" />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>

              {/* Content */}
              <p className="text-slate-300 mb-6 line-clamp-4">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center text-white font-bold text-sm">
                  {testimonial.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{testimonial.name}</div>
                  <div className="text-xs text-slate-400">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
